import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLeadDetailsComponent } from "modules/user_management/store/permissionsStore";

const NEXT_CALL_V2_ROUTE = "/next-call-v2";

/**
 * Back pill rendered in the minimal topbar (/next-call, /next-call-v2, /chat).
 *
 * On next-call-v2 ONLY it honours the same `back-button` RBAC flag that already
 * gates the in-page header arrow (actionables_v2/EngagementHeader). Without this
 * the flag was bypassable: a coach denied the header arrow could still leave the
 * customer profile through this pill.
 *
 * /next-call and /chat are intentionally out of scope — they share the minimal
 * layout but are not the surface the flag was introduced for.
 */
const MinimalBackButton = () => {
  const { pathname } = useLocation();
  const canShowBackButton = useLeadDetailsComponent("back-button");

  // Prefix match mirrors useLayoutMode.js so /next-call-v2/:id is covered too.
  const isNextCallV2 =
    pathname === NEXT_CALL_V2_ROUTE ||
    pathname.startsWith(`${NEXT_CALL_V2_ROUTE}/`);

  if (isNextCallV2 && !canShowBackButton) return null;

  return (
    <Link to="/" className="topbar__back-btn">
      <FontAwesomeIcon icon="arrow-left" />
      <span>Back</span>
    </Link>
  );
};

export default MinimalBackButton;
